import { Component, OnInit} from "@angular/core";
import { ApiPathsService } from "src/app/api-paths.service";
import { environment } from "src/environments/environment";
import { Circle_Marker } from "../models/Circle_Marker";
import { CampoUtility } from "../models/campo-aggiuntivo";
import { ApiRestService } from "src/app/Admin/_service/api-rest.service";
@Component({
    selector: 'app-dynamic-plan',
    templateUrl: './dynamic-plan.component.html'
})
export class DynamicPlanComponent implements OnInit{
    filtro: any = {};
    environment = environment;
    interventiList: any[] = [];
    centerMaplat: number = 41.4910946;
    centerMaplon: number = 12.7142646;
    circleMarker: Circle_Marker = { latitude: 41.4910946, longitude: 12.7142646, radius: 50000, editable: true, circleDraggable: true, fillColor: "blue", fillOpacity:0.5};
    page = 1;
    pageSize = 5;
    pagesizeserver = 4
    newpagegenerated = 1;
    Markers: any[] = [];

    
    constructor(private api: ApiPathsService, private campoUtility: CampoUtility, private apiRest: ApiRestService){

    }

    ngOnInit(): void {
        this.filtro = environment['PianificazioneAddOn']['defaultFilters'] ?? {};
        this.refresh();

    }


    refresh() {
        this.filtro.periodo = true;
        this.filtro.page = this.page;
        this.filtro.size = this.pageSize;
        this.api.ClassicPost(environment['PianificazioneAddOn']['restRoute'], this.filtro).subscribe(data => {
    
            this.interventiList = data?.data ?? [];
    
    
            this.buildMarkers();
        })
    }
    
    

    select(item: any) {
        item.selected = !item.selected;
    
        this.Markers = this.Markers.map(m => {
            if (m.id === item.id) {
                return {
                    ...m,
                    selected: item.selected,
                    icon: this.getMarkerIcon(item)  // 👈 icon, non iconUrl
                };
            }
            return m;
        });
    }
    
    

    buildMarkers() {
        const newMarkers = [];
    
        for (let int of this.interventiList) {
    
            if ((!int.latitudine || !int.longitudine) && environment['PianificazioneAddOn']['geolocalizzazione']) {
                this.geolocalizzaIntervento(int);
            }
    
            newMarkers.push({
                id: int.id,
                lat: Number(int.latitudine),
                lng: Number(int.longitudine),
                selected: int.selected ?? false,
                programmato: int.programmato ?? false,
                altrui: int.altrui ?? false,
                icon: this.getMarkerIcon(int),   // 👈 CAMBIATO iconUrl → icon
                interventoObject: int,
                visible: true,
                draggable: false
            });
        }
    
        this.Markers = [...newMarkers];  // 👈 ARRAY NUOVO = FORZA RENDER
    
        if (this.Markers.length > 0) {
            this.centerMaplat = this.Markers[0].lat;
            this.centerMaplon = this.Markers[0].lng;
        }
    
        console.log("MARKERS:", this.Markers);
    }
    
    
    geolocalizzaIntervento(intervento: any) {
    
        /*const fullAddress = this.fulladdr(intervento.acquirente); //per il momento sta acquirente perchè sto con i dati di test
        console.log("FULL ADDRESS: ", fullAddress);
        if (!fullAddress || fullAddress.trim() === "") return;*/
    
        /*this.apiRest.getCoordinate(fullAddress).subscribe(response => {
    
            const location = response?.results?.[0]?.geometry?.location;
    
            if (location) {
                intervento.latitudine = location.lat;
                intervento.longitudine = location.lng;
    
                // dopo aver aggiornato rigenero i markers
                this.buildMarkers();
            } else {
                console.warn("Coordinate non trovate per:", fullAddress);
            }
        });*/
        /*intervento.latitudine = Math.random() + 30;
        intervento.longitudine = Math.random() + 30;
        this.buildMarkers();*/
        intervento.latitudine = Math.random() + 41.4910946;
    intervento.longitudine = Math.random() + 12.7142646;
    }
    

    getMarkerIcon(intervento: any): string {

        return 'http://maps.google.com/mapfiles/ms/icons/yellow.png'
    }
    
    onMarkerClick(event: any) {
        const marker = this.Markers.find(m => m.id === event.id);
    
        if (!marker) return;
    
        this.select(marker.interventoObject);
    }
    
    fulladdr(cliente: any) : string{
        return (cliente?.indirizzo ?? "") + (cliente?.citta? ("," + cliente?.citta) : "") + (cliente?.provincia? ("," + cliente?.provincia) : "");
    }

    CampoIs(campo: any, types: string[], inputTypes: string[]) {
        return types?.includes(campo.type) || inputTypes?.includes(campo.inputType)
      }

    
    
}